import { Link, graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useRef } from "react"
import NavItems from "./navItems"
import SmallScreenMenu from "./smallScreenMenu"
import headerStyles from "./header.module.scss"
import commonHeaderStyles from "./commonHeader.module.scss"

const Header = ({ isSmallScreen }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          defaultTitle
        }
      }
    }
  `)

  const navRef = useRef(null)
  const bannerRef = useRef(null)
  const spacerRef = useRef(null)

  const handleScroll = () => {
    const refCurrent = navRef.current
    if (!refCurrent) return

    const bannerCurrent = bannerRef.current
    const navHeight = refCurrent ? refCurrent.offsetHeight : 0

    if (!bannerCurrent) return

    const rect = bannerCurrent.getBoundingClientRect()
    const shouldBeSticky = rect.bottom <= 0

    if (shouldBeSticky) {
      refCurrent.classList.add(
        headerStyles.fixedHeader,
        headerStyles.fixedHeaderOpaque
      )

      const headerEl = refCurrent.closest("header")
      const headerHeight = headerEl ? headerEl.offsetHeight : 0
      const spacerHeight = Math.max(0, navHeight - headerHeight)
      if (spacerRef.current) {
        spacerRef.current.style.height = spacerHeight + "px"
      }
    } else {
      refCurrent.classList.remove(
        headerStyles.fixedHeader,
        headerStyles.fixedHeaderOpaque
      )
      if (spacerRef.current) {
        spacerRef.current.style.height = "0px"
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    window.addEventListener("resize", handleScroll)
    handleScroll()

    let ro
    if (bannerRef.current && typeof window.ResizeObserver === "function") {
      ro = new ResizeObserver(handleScroll)
      ro.observe(bannerRef.current)
    }

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", handleScroll)
      if (ro) {
        ro.disconnect()
      }
    }
  }, [])

  const navContainer = (
    <header>
      <nav ref={navRef} className={commonHeaderStyles.commonNav}>
        <span className={headerStyles.navAndTitleContainer}>
          <h1 className={headerStyles.title}>
            <Link to="/">{data.site.siteMetadata.defaultTitle}</Link>
          </h1>
          {isSmallScreen ? <SmallScreenMenu /> : <NavItems />}
        </span>
      </nav>
    </header>
  )

  return (
    <>
      <div ref={bannerRef} className={headerStyles.headerBanner}></div>
      {navContainer}
      <div ref={spacerRef} aria-hidden="true" />
    </>
  )
}

export default Header
